import { render } from "./UniversalSearch.vue?vue&type=template&id=1c35bdde"
import script from "./UniversalSearch.vue?vue&type=script&lang=js"
export * from "./UniversalSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__